import { useEffect, useState } from 'react';

export function useInitialLoad(options: {
  reduxLoadingSelector: () => boolean;
  hasDataSelector: () => boolean;
}): boolean {
  const { reduxLoadingSelector, hasDataSelector } = options;
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const reduxLoading = reduxLoadingSelector();
  const hasData = hasDataSelector();

  useEffect(() => {
    if (hasData && !reduxLoading) {
      setHasLoadedOnce(true);
    }
  }, [hasData, reduxLoading]);

  if (hasLoadedOnce) {
    return false;
  }

  return reduxLoading && !hasData;
}
